module.exports = __webpack_public_path__ + "static/media/005-Wechseln_ID_17.e18ef2e5.mp3";